import React from "react";
import classNames from "classnames";
import { ReactComponent as CloseIcon } from "../../../images/icons/elements/close-icon.svg";

export type TableModalProps = {
  onClose?: () => void;
  onApply?: () => void;
  title?: string;
  customApplyIcon?: React.ReactElement;
  modalContent?: React.ReactNode;
  additionalClassName?: string;
};

const TableModal: React.FC<TableModalProps> = (props) => {
  const {
    onClose,
    title,
    onApply,
    modalContent,
    additionalClassName,
    customApplyIcon,
  } = props;

  return (
    <div className="table-modal__content">
      <div className="table-modal__header">
        <div className="table-modal__title">{title}</div>
        <div className="table-modal__header-close">
          <CloseIcon onClick={onClose} />
        </div>
      </div>
      <div className="table-modal__body">{modalContent}</div>
      <div className="table-modal__footer">
        <div
          onClick={onApply}
          className={classNames(
            "table-modal__footer-apply",
            additionalClassName
          )}
        >
          {customApplyIcon}
        </div>
      </div>
    </div>
  );
};

export default TableModal;
